module.exports = __webpack_public_path__ + "static/media/delete.3df96e6b.png";